import { MedicalField } from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { InteractiveTable, InteractiveTableCellProps } from '@dreryk/react-components';

import { healthcareOrganizationTranslationKeys } from '../../../../../translations';

import {
   medicalFieldItemRenderer,
   medicalFieldKeyExtractor,
   medicalFieldLabelExtractor,
   medicalFieldSearchCreator,
} from './MedicalFieldAutosuggestCell.utils';

type MedicalFieldAutosuggestCellProps = InteractiveTableCellProps<MedicalField>;

export const MedicalFieldAutosuggestCell = (props: MedicalFieldAutosuggestCellProps): JSX.Element => {
   return (
      <InteractiveTable.AutosuggestCell<MedicalField>
         testId={props.testId}
         name={props.name}
         index={props.index}
         defaultValue={props.defaultValue}
         itemRenderer={medicalFieldItemRenderer}
         textInputValueExtractor={medicalFieldLabelExtractor}
         keyExtractor={medicalFieldKeyExtractor}
         searchCreator={medicalFieldSearchCreator}
         placeholder={healthcareOrganizationTranslationKeys.searchByCodeOrName}
         minChars={0}
      />
   );
};
